// src/ConsumerApp/api/profile/profile.hooks.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileService } from './profile.service';

export const useGetProfileDetails = (customerId, token, options = {}) => {
  return useQuery({
    queryKey: ['profile', customerId],
    queryFn: () => profileService.getProfileDetails(customerId, token),
    enabled: Boolean(customerId),
    select: (res) => res?.data || res || null,
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};

export const useUpdateProfileDetails = (token) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => profileService.updateProfileDetails(payload, token),
    onSuccess: (data, variables) => {
      // 1. Invalidate TanStack query cache so sidebar and profile re-render immediately
      queryClient.invalidateQueries({ queryKey: ['profile', variables.id] });

      // 2. Sync updated name and type to sessionStorage / localStorage
      try {
        const stored = sessionStorage.getItem('userData') || localStorage.getItem('userData');
        if (stored) {
          const parsed = JSON.parse(stored);
          const updated = {
            ...parsed,
            name: variables.name,
            customer_name: variables.name,
            phone: variables.mobile,
            mobile_number: variables.mobile,
            customer_type: variables.selectedBuyerType,
          };
          sessionStorage.setItem('userData', JSON.stringify(updated));
          localStorage.setItem('userData', JSON.stringify(updated));
        }
      } catch (e) {
        console.warn('Session sync skipped:', e);
      }
    },
  });
};

export const useDeleteCustomerAccount = (token) => {
  return useMutation({
    mutationFn: (payload) => profileService.deleteCustomerAccount(payload, token),
  });
};

export const useCustomerLogout = (token) => {
  return useMutation({
    mutationFn: () => profileService.customerLogout(token),
  });
};